/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIGovernanceLabelFiltersResponse {
    getFixupPrototypeFunction() { return AIGovernanceLabelFiltersResponse.fixupPrototype; }

    static newInstance(model: Partial<AIGovernanceLabelFiltersResponse>): AIGovernanceLabelFiltersResponse {
        let obj = Object.assign(new AIGovernanceLabelFiltersResponse(), model);
        AIGovernanceLabelFiltersResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIGovernanceLabelFiltersResponse>): AIGovernanceLabelFiltersResponse {
        if (!model) return null;
        return AIGovernanceLabelFiltersResponse.newInstance(<AIGovernanceLabelFiltersResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIGovernanceLabelFiltersResponse) {
        if (!obj) return;

        models.AIGovernanceLabelFiltersResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIGovernanceLabelFiltersResponse): boolean {
        Object.setPrototypeOf(obj, AIGovernanceLabelFiltersResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.labels) {
            for (let val of this.labels) {
                models.KeyValues.fixupPrototype(val);
            }
        }
    }

    /**
     * Distinct label keys and the values observed for each, for building filter UIs
     */
    labels: Array<models.KeyValues>;

}
